import {ContentModelName, DeviceOS} from "../contenful/types";
import {createSelector} from "reselect";
import {AppState} from "../RootReducer";
import {ContentStatus} from "../contenful/ContentfulReducer";
import {getSettings, getCurrencyDefinitions} from "./settings-selectors";
import {Settings} from "../http/protocol";
import {BannerJackpotAmount, getJackpotById} from './casino-selectors'
import { getActiveCurrency, getUserAttributes } from './user-selectors';
import {getJackpots} from "./shared-selectors";

const getContentModelName = (_:any, name :ContentModelName) => name;
const getContentStatuses = (app : AppState) => app.contentful.contentModelStatus ?? {};

export const getStatusForContent = createSelector([getContentStatuses,getContentModelName], (statuses, name) => {
    return statuses[name] ?? ContentStatus.NONE;
});

const getDeviceOS = (_:any, os : DeviceOS) : DeviceOS => {
    return os;
}
const _isAppEnabled = (includeOnlyMobile? : boolean, deviceOS? : DeviceOS, settings? : Settings) => {
    if(!deviceOS) {
        return false;
    }
    if(settings?.pwaEnabled) {
        if(deviceOS == "Android" && settings.pwaEnabledAndroid) {
            return true;
        } else if(includeOnlyMobile === false && deviceOS == "Windows" && settings.pwaEnabledWindows) {
            return true;
        } else if(deviceOS == "iOS" && settings.pwaEnabledIOS) {
            return true;
        }
    }
    return false;
}
export const isAppEnabledForDevice = createSelector([getSettings,getDeviceOS], (settings, deviceOS) => {
    return _isAppEnabled(true,deviceOS,settings);
});
export const isAppPopupEnabledForDevice = createSelector([getSettings, getDeviceOS], (settings, deviceOS) => {
    let isAppEnabled = _isAppEnabled(true,deviceOS,settings);
    return isAppEnabled && settings?.appPopupEnabled;
});

export const getPopupManager = (app : AppState) => app.contentful.popupManager;


const getJackpotInfo = (_:any, data : {id: string, currency: string}) => data;


export const getJackpotForPanel = createSelector(
    [getActiveCurrency, getCurrencyDefinitions, getUserAttributes, getSettings, getJackpots, getJackpotInfo ], (activeCurrency, currencies, userAttributes, settings, jackpots, data ) =>{
    const jackpot = getJackpotById(jackpots, settings, currencies, activeCurrency, userAttributes, data.id, data.currency)
    if(!data.id){
        return undefined
    }
    let formattedJackpots: BannerJackpotAmount[] = []
    if(jackpot){
        formattedJackpots.push({
            id : data.id,
            formattedAmount : jackpot?.formattedAmount,
            jackpotCurrency : data.currency,
            amount : jackpot?.amount,
            currency : jackpot?.currency
        })
    }
    return formattedJackpots 
})

